 
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetselectedContactInfoService {

  constructor(private http: HttpClient) {}

  async GetSelectedContactInfo(id) {
    try { 
      let response = await this.http
        .get(`${appApiResources.getSelectedContactInfo}/${id}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}
